// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./component/Login/Login";
import Dashboard from "./component/Dashboard/Dashboard";
import NotFound from "./component/NotFound/NotFound";
import { AuthProvider } from "./component/AuthContext";
import PetitionManagement from "./component/PetitionManagement/PetitionManagement";
import Source from "./component/Source/Source";
import Categories from "./component/Categories/Categories";
import Assigne from "./component/Assigne/Assigne";
import PrivateRoute from "./component/PrivateRoute";
import Users from "./component/users/users";
import ChangePassword from "./component/ChangePassword/ChangePassword";
import AssigneSearch from "./component/AssigneSearch/AssigneSearch";
import AddItem from "./component/AddItem/AddItem";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<PrivateRoute />}>
            <Route path="" element={<Dashboard />}>
              <Route path="Admin" element={<Users />} />
              <Route
                path="PetitionManagement"
                element={<PetitionManagement />}
              />
              <Route path="Source" element={<Source />} />
              <Route path="Categories" element={<Categories />} />
              <Route path="Assigne" element={<Assigne />} />
              <Route path="AssigneSearch" element={<AssigneSearch />} />
              <Route path="AddItem" element={<AddItem />} />

              <Route path="ChangePassword" element={<ChangePassword />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
